import { ReactComponent as CollapseIcon } from "../../Assets/collapse-window.svg";
import { ReactComponent as ExpandIcon } from "../../Assets/expand-window.svg";
import { useConfigStore } from "../../Stores/Config";
import { AppMode, useRouterStore } from "../../Stores/Router";
import { useWidgetSizeStore } from "../../Stores/WidgetSize";
import IconButton from "../IconButton/IconButton";

// Lets the end user switch the web widget between the compact and the expanded
// window. Rendered next to every close button; renders nothing unless the host
// SDK reports that the widget can be expanded (desktop, not a survey, not
// disabled by the project).
function ExpandWidgetButton({
  className,
  variant = "icon",
}: {
  className?: string;
  variant?: "icon" | "home-v4";
}) {
  const configStore = useConfigStore();
  const appMode = useRouterStore((state) => state.appMode);
  const { expandable, expanded, setExpanded } = useWidgetSizeStore();

  if (!expandable || appMode !== AppMode.WIDGET) {
    return null;
  }

  const Icon = expanded ? CollapseIcon : ExpandIcon;
  const label = expanded
    ? configStore.translateTextWithFallback("collapseWindow", "Collapse window")
    : configStore.translateTextWithFallback("expandWindow", "Expand window");
  const toggle = () => setExpanded(!expanded);

  if (variant === "home-v4") {
    return (
      <button
        type="button"
        className="agent-home-v4-header-btn agent-home-v4-header-btn--expand"
        aria-label={label}
        onClick={toggle}
      >
        <Icon aria-hidden="true" focusable="false" />
      </button>
    );
  }

  return (
    <IconButton
      icon={Icon}
      ariaLabel={label}
      className={`expand-widget-button ${className ?? ""}`}
      onClick={toggle}
    />
  );
}

export default ExpandWidgetButton;
